import React, { FC } from 'react';
import NavigationLink from 'src/shared-components/NavigationLink/NavigationLink';
import { bookingStatusUpdate } from 'src/utils/links';
import { generateComment } from '../utils';

const ChangingDrugCart: FC = () => {
  return (
    <div>
      <p className="mb-1">
        Якщо клієнт побажав додати, прибрати товар або змінити кількість товарів
        у списку, необхідно за допомогою API
        <span className="fs-body-bold"> POST </span>
        <NavigationLink passClassName="underline " href={bookingStatusUpdate}>
          {bookingStatusUpdate}
        </NavigationLink>
        <span>
          {' '}
          відправити інформацію про новий список товарів в замовленні у полі
          items:
        </span>
      </p>

      <p>Request:</p>
      <pre>
        <code>
          &#123;
          <p className="indent-6">
            &quot;orderCode&quot;: &quot;123456&quot;,{' '}
            {generateComment('код замовлення Likie')};
          </p>
          <p className="indent-6">
            &quot;orderCode&quot;: &quot;12345678&quot;,{' '}
            {generateComment('код замовлення')}
            партнера
          </p>
          <p className="indent-6">
            &quot;orderStatus&quot;: &quot;APPROVED&quot;,{' '}
            {generateComment('статус замовлення')}
          </p>
          <p className="indent-6">
            &quot;message&quot;: &quot;успешно забронировано&quot;,
            {generateComment('повідомлення')}
          </p>
          <p className="indent-6">
            &quot;items&quot;: &#91; {generateComment('товари')}
          </p>
          <p className="indent-10">&#123;</p>
          <p className="indent-12">
            &quot;restCode&quot;: &quot;421552&quot;,{' '}
            {generateComment('код товару')}
          </p>
          <p className="indent-12">
            &quot;quantity&quot;: 10,{' '}
            {generateComment('кількість пачок товару')}
          </p>
          <p className="indent-12">
            &quot;price&quot;: 9.99, {generateComment('ціна товару')}
          </p>
          <p className="indent-10">&#125;</p>
          <p className="indent-8">&#93;</p>
          &#125;
        </code>
      </pre>
    </div>
  );
};

export default ChangingDrugCart;
